module.exports = __webpack_public_path__ + "static/media/094.89ab7f25.jpg";